// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__16Y88","title":"AfterBackImages_title__pZoaz","images":"AfterBackImages_images__3OFBg"};